import MainMenu from './MainMenu.vue'

export default MainMenu
